<div class="unlock-slider">

  <div class="unlock-track" #track>

    <div class="unlock-label no-select" [class.unlocked]="isUnlocked">
      {{ isUnlocked ? 'Abierto' : label }}
    </div>

    <div
      #handle
      class="unlock-handle"
      [class.dragging]="isDragging"
      [class.unlocked]="isUnlocked"
      [style.transform]="'translate(' + currentX + 'px, -50%)'"
      (pointerdown)="onDragStart($event)"
    >
      <div class="icon-circle">
        <!-- Candado en SVG para que no dependas de icon fonts -->
        <svg viewBox="0 0 24 24" class="lock-icon" aria-hidden="true">
          <path
            d="M12 2a4 4 0 0 0-4 4v3H7a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2h-1V6a4 4 0 0 0-4-4zm-2 4a2 2 0 1 1 4 0v3h-4V6zm2 6a1.5 1.5 0 0 1 1.5 1.5c0 .6-.35 1.11-.86 1.35L13 18h-2l.36-3.15a1.5 1.5 0 0 1-.86-1.35A1.5 1.5 0 0 1 12 12z"
          />
        </svg>
      </div>
    </div>

  </div>

</div>
